import {Token} from '@primer/react'
import {colorNames, useNamedColor} from '@github-ui/use-named-color'
import {graphql} from 'relay-runtime'
import {useFragment} from 'react-relay'
import type {HeaderIssueType$key} from './__generated__/HeaderIssueType.graphql'
import styles from './HeaderIssueType.module.css'

export type HeaderIssueTypeProps = {
  data: HeaderIssueType$key
}

const IssueTypeFragment = graphql`
  fragment HeaderIssueType on Issue {
    viewerCanSeeIssueType
    issueType {
      name
      color
    }
  }
`

export function HeaderIssueType({data}: HeaderIssueTypeProps) {
  const {viewerCanSeeIssueType, issueType} = useFragment<HeaderIssueType$key>(IssueTypeFragment, data)
  const effectiveColor = colorNames.find(c => c === issueType?.color)
  const {fg, bg, border} = useNamedColor(effectiveColor || 'GRAY')

  if (!viewerCanSeeIssueType || !issueType) return null

  return (
    <Token
      size="large"
      sx={{
        height: '32px',
        px: 'var(--control-small-paddingInline-normal)',
        display: 'flex',
        color: fg,
        backgroundColor: bg,
        borderColor: border,
      }}
      text={<span className={styles.tokenText}>{issueType.name}</span>}
    />
  )
}

export const SmallHeaderIssueType = ({data}: HeaderIssueTypeProps) => {
  const {viewerCanSeeIssueType, issueType} = useFragment<HeaderIssueType$key>(IssueTypeFragment, data)

  if (!viewerCanSeeIssueType || !issueType) return null

  return <div className={styles.smallToken}>{issueType.name}</div>
}

try{ HeaderIssueType.displayName ||= 'HeaderIssueType' } catch {}
try{ SmallHeaderIssueType.displayName ||= 'SmallHeaderIssueType' } catch {}